import script from "./DressCode.vue?vue&type=script&setup=true&lang=js"
export * from "./DressCode.vue?vue&type=script&setup=true&lang=js"

import "./DressCode.vue?vue&type=style&index=0&id=828e3e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-828e3e7c"]])

export default __exports__